<template>
  <div class="min-h-full bg-cream px-4 pt-12 pb-24">
    <ProfilePageHeader title="Рекомендации по питанию" />
    <p class="page-hint">Выберите актуальные рекомендации по питанию, чтобы Зоя учитывала при анализе и ответах</p>

    <div class="chip-list mb-5">
      <button
        v-for="item in RECOMMENDATIONS"
        :key="item"
        class="chip"
        :class="{ selected: selected.includes(item) }"
        @click="toggle(item)"
      >{{ item }}</button>
    </div>

    <h2 class="field-title">Что-то ещё</h2>
    <p class="field-hint">Например: без острого, больше овощей</p>
    <textarea
      v-model="note"
      rows="4"
      placeholder="Напишите своими словами"
      class="w-full mb-4 px-4 py-4 rounded-2xl bg-tip text-14 text-ink outline-none border-0 resize-none leading-relaxed"
      style="font-family: Inter, sans-serif;"
    />

    <p v-if="saveStatus" class="text-12 text-ink/70 text-center mb-4">{{ saveStatus }}</p>

    <button
      @click="$router.push('/profile')"
      class="w-full py-3 rounded-2xl bg-ink text-cream text-15 font-semibold"
    >
      Назад в Профиль
    </button>
  </div>
</template>

<script setup>
import ProfilePageHeader from '../components/ProfilePageHeader.vue'
import { ref, watch, onMounted, nextTick } from 'vue'
import { useAuthStore } from '../store/auth.js'

const authStore = useAuthStore()

// Формулировки, а не коды: единственный потребитель — языковая модель, а текст
// не требует держать словарь ещё и на сервере, где копия однажды разойдётся.
// Это следствия для питания, а не состояния здоровья — так и собранных данных
// меньше, и Зое сразу понятно, что делать.
const RECOMMENDATIONS = [
  'Меньше соли',
  'Меньше сахара и быстрых углеводов',
  'Меньше насыщенных жиров',
  'Больше клетчатки',
  'Больше белка',
  'Больше железа',
  'Больше кальция и витамина D',
  'Больше омега-3',
  'Без глютена',
  'Без лактозы',
  'Меньше кофеина',
  'Без алкоголя',
  'Больше воды',
]

const saved = authStore.user?.nutrition_notes || {}
const selected = ref(Array.isArray(saved.selected) ? [...saved.selected] : [])
const note = ref(saved.note || '')
const saveStatus = ref('')
let saveTimer = null
const isReady = ref(false)

onMounted(() => { nextTick(() => { isReady.value = true }) })

function toggle(item) {
  const i = selected.value.indexOf(item)
  if (i === -1) selected.value.push(item)
  else selected.value.splice(i, 1)
}

// Одно сохранение на чекбоксы и текст: правятся на одном экране.
// Об успехе не сообщаем — отметка тега видна сама по себе, а всплывающая
// строка сдвигала кнопку под ней при каждом нажатии. Показываем только сбой.
function scheduleSave() {
  if (!isReady.value) return
  saveStatus.value = ''
  clearTimeout(saveTimer)
  saveTimer = setTimeout(async () => {
    try {
      const value = { selected: selected.value, note: note.value.trim() }
      const empty = !value.selected.length && !value.note
      await authStore.updateProfile({ nutrition_notes: empty ? null : value })
    } catch {
      saveStatus.value = 'Ошибка сохранения'
    }
  }, 1000)
}

watch(selected, scheduleSave, { deep: true })
watch(note, scheduleSave)
</script>

<style scoped>
.page-hint {
  font-size: var(--fs-14);
  color: var(--ink-70);
  line-height: 1.35;
  margin-bottom: 16px;
}
.chip-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.chip {
  padding: 9px 14px;
  border-radius: 999px;
  border: 1.5px solid rgba(65, 41, 26, 0.18);
  background: transparent;
  color: var(--ink);
  font-family: inherit;
  font-size: var(--fs-14);
  line-height: 1.2;
  text-align: left;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s, color 0.15s;
}
.chip.selected {
  background: #41291A;
  border-color: var(--ink);
  color: var(--cream);
}
.field-title {
  font-size: var(--fs-17);
  font-weight: 700;
  color: var(--ink);
  margin-bottom: 2px;
}
.field-hint {
  font-size: var(--fs-14);
  color: var(--ink-70);
  line-height: 1.3;
  margin-bottom: 8px;
}
textarea::placeholder {
  color: var(--ink-70);
}
</style>
